import * as React from 'react';
import { styled } from '@mui/system';
import { Typography } from '@mui/material';

const NoteTitle = styled(Typography)(({ theme }) => ({
  fontFamily: 'Fjalla One',
  fontWeight: 400,
  fontSize: '22px',
  lineHeight: '25px',
  textAlign: 'center',

  [theme.breakpoints.down('sm')]: {
    textAlign: 'left',
    paddingLeft: '23px',
    fontSize: '17px',
    lineHeight: '21px',
  },
}));

const DisplayTextName = styled('span')({
  color: 'rgb(166,146,123)',
});

const SharedNoteTitles = (props) => {
  const { typeofTitle, displayName } = props;
  return (
    <>
      <NoteTitle>
        {typeofTitle}
        <DisplayTextName> {displayName}</DisplayTextName>
      </NoteTitle>
    </>
  );
};

export default SharedNoteTitles;
